import React from 'react'
import moment from 'moment-timezone';
import { IntlProvider } from 'react-intl';
import { connect } from "react-redux";

import HelpDialog from "../components/HelpDialog";
import MultiStore from "../components/MultiStore";
import ErrorPage from "../components/ErrorPage";
import '../components/Layout/LoadingScreen/LoadingScreen.scss';

import history from "../history";
import BookingRouter from '../Routes';

import CustomerIdentifier from '../utils/CustomerIdentifier';
import LocaleRetriever from '../utils/LocaleRetriever';
import request from '../utils/request';
import QueryStringRetriever from "../utils/QueryStringRetriever";
import { 
    setSessionId, getTimestamp, setTimestamp, getCustomerConfig, getSessionId, getSystemSettings, setSpotlioSessionId, getSpotlioSessionId, getFormData, getDestination, setDestination, getUserSettings, getSeason, setSeason, getLocale 
} from '../utils/SettingsRetriever';
import saveDestination from "../utils/saveDestination";
import SalesIDRetriever from '../utils/SalesIDRetriever';
import { initGA } from "../utils/ga";
import { initFBPX } from "../utils/fbpixel";
import { getCookie, setCookie } from '../utils/CookiesRetriever';
import PushHistory from '../utils/PushHistory';
import CurrencyDatabase from '../utils/CurrencyDatabase';

import { getItinerary as globalGetItinerary } from '../services/cart';
import { setForm } from "../services/form";

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            customerState: false,
            settings: null,
            customerCalled: false,
            locale: null,
            error: null,
        }
        this.adminMail = null;

        window.onerror = (message,file,line,column,errorObject) => {
            column = column || (window.event && window.event.errorCharacter);
            let stack = errorObject ? errorObject.stack : null;

            //trying to get stack from IE
            if (!stack) {
                //eslint-disable-next-line
                let stack = [];
                //eslint-disable-next-line
                let f = arguments.callee.caller;
                while (f) {
                    stack.push(f.name);
                    f = f.caller;
                }
                errorObject['stack'] = stack;
            }

            // const data = {
            //     message:message,
            //     file:file,
            //     line:line,
            //     column:column,
            //     errorStack:stack,
            // };

            //here I make a call to the server to log the error
            process.env.NODE_ENV === 'production' && this.handleReportError(message, stack);
        }
    }

    componentDidMount() {
        this.CheckForLatestVersion().then((version) => {
            CustomerIdentifier(version.netonline).then((configs) => {
                if (configs[1] && configs[1].app && configs[1].app.adminMail) {
                    this.adminMail = configs[1].app.adminMail;
                }
                if (getFormData() && getFormData().activities && getFormData().lodging){
                    setForm(getFormData())
                } else {
                    let form = {
                        "lodging": {
                            "arrivalDate": moment.utc().add(2, 'days').format("YYYY-MM-DD"),
                            "nights": 2,
                            "adults": 1,
                            "children": 0
                        },
                        "activities": {
                            "startDate": moment.utc().add(2, 'days').format("YYYY-MM-DD"),
                            "rangeOfDays": 0
                        },
                        "liftTickets": {
                            "category": 117,
                            "days": 2,
                            "month": 9,
                            "year": 2020
                        },
                        "flights": {
                            "arrivalDate": moment.utc().add(2, 'days').format("YYYY-MM-DD"),
                            "departureDate": moment.utc().add(4, 'days').format("YYYY-MM-DD"),
                            "departureAirport": {
                                "short": "BCN",
                                "name": "BCN Barcelona Arpt"
                            },
                            "arrivalAirport": "DFW",
                            "adults": 1,
                            "children": 0
                        },
                        "carRentals": {
                            "arrivalDate": moment.utc().add(2, 'days').format("YYYY-MM-DD"),
                            "departureDate": moment.utc().add(4, 'days').format("YYYY-MM-DD"),
                            "location": {
                                "short": "HDN",
                                "name": "HDN Hayden Arpt"
                            },
                            "pickUpHour": "10:00 AM",
                            "dropOffHour": "10:00 AM"
                        }
                    }
                    if (configs[1] && configs[1].app && configs[1].app.forms){
                        if (configs[1].app.forms.lodging){
                            form.lodging = configs[1].app.forms.lodging;
                            if (configs[1].app.forms.lodging.mode && configs[1].app.forms.lodging.mode === "manual"){
                                form.lodging.arrivalDate = moment.utc().add(configs[1].app.forms.lodging.arrivalDate, 'days').format("YYYY-MM-DD");
                            }
                        }
                        if (configs[1].app.forms.activities) {
                            form.activities = configs[1].app.forms.activities;
                            if (configs[1].app.forms.activities.mode && configs[1].app.forms.activities.mode === "manual"){
                                form.activities.startDate = moment.utc().add(configs[1].app.forms.activities.startDate, 'days').format("YYYY-MM-DD");
                            }
                        }
                        if (configs[1].app.forms.flights) {
                            form.flights = configs[1].app.forms.flights;
                            if (configs[1].app.forms.flights.mode && configs[1].app.forms.flights.mode === "manual"){
                                form.flights.arrivalDate = moment.utc().add(configs[1].app.forms.flights.arrivalDate, 'days').format("YYYY-MM-DD");
                                form.flights.departureDate = moment.utc().add(configs[1].app.forms.flights.departureDate, 'days').format("YYYY-MM-DD");
                            }
                        }
    
                        if (configs[1].app.forms.liftTickets){
                            form.liftTickets = configs[1].app.forms.liftTickets;
                        }

                        if (configs[1].app.forms.carRentals){
                            form.carRentals = configs[1].app.forms.carRentals;
                            if (configs[1].app.forms.carRentals.mode && configs[1].app.forms.carRentals.mode === "manual"){
                                form.carRentals.arrivalDate = moment.utc().add(configs[1].app.forms.carRentals.arrivalDate, 'days').format("YYYY-MM-DD");
                                form.carRentals.departureDate = moment.utc().add(configs[1].app.forms.carRentals.departureDate, 'days').format("YYYY-MM-DD");
                            }
                        }
                    }
                    setForm(form)
                }
    
                const SystemSettings = configs[1];
    
                // multiDestination check
                if (SystemSettings.multiDestination && SystemSettings.multiDestination.enabled){
                    let qs = QueryStringRetriever();
                    if (!qs.s_dest_id){
                        if (!getDestination() && window.location.href.indexOf("select_destination") < 0 && window.location.href.indexOf("account") < 0 && window.location.href.indexOf("login") < 0 && window.location.href.indexOf("shopping-cart") < 0){
                            PushHistory("/select_destination");
                        }
                    } else {
                        let destination = [];
                        if (qs.s_dest_id.toString().indexOf(",") >= 0 && qs.s_dest_id.toString().indexOf("all") < 0){
                            destination = qs.s_dest_id.split(",")
                        } else {
                            if (qs.s_dest_id.toString().indexOf("all") >= 0){
                                SystemSettings.multiDestination.list.forEach(dest => {
                                    destination.push(parseInt(dest.id))
                                })
                            } else {
                                destination.push(parseInt(qs.s_dest_id))
                            }
                        }
                        if (destination.length > 0) { 
                            if (destination !== getDestination()){
                                setDestination(false);
                                destination.forEach(dest => {
                                    if (SystemSettings.multiDestination.list.find(d => d.id === parseInt(dest))){
                                        saveDestination(dest)
                                    }
                                })
                            }
                        } else {
                            PushHistory("/select_destination");
                        }
                    }
                }

                // crossDomain check

                if (SystemSettings && SystemSettings.app && SystemSettings.app.crossDomain && SystemSettings.app.crossDomain.enabled) {
                    const crossDomainConfig = SystemSettings.app.crossDomain;
                    let qs = QueryStringRetriever();
                    if (qs.currency === "USD") {
                      let currentPath = window.location.pathname;
                      let replacedString = currentPath + window.location.search;
                      const redirectURL = "https://booking.skibig3.com";
                  
                      if (crossDomainConfig.packageMapping) {
                        crossDomainConfig.packageMapping.forEach(({ originalId, newId }) => {
                          const regex = new RegExp(originalId, "g");
                          replacedString = replacedString.replace(regex, newId);
                        });
                      }
                  
                      window.location.href = redirectURL + replacedString;
                    }
                  }

                // seasonality check
                if (SystemSettings.seasonality && SystemSettings.seasonality.enabled && !getSeason()){
                    let season = SystemSettings.seasonality.list.find(s => s.isDefault === true);

                    if (!season) {
                        // no one season item is marked as isDefault
                        season = SystemSettings.seasonality.list[SystemSettings.seasonality.list.length - 1];
                    }

                    let seasonStartDate = moment.utc(season.start).startOf("day");
                    let seasonEndDate = moment.utc(season.end).startOf("day");
                    let today = moment.utc().startOf("day");
                    if (!season || today.isBefore(seasonStartDate) || today.isAfter(seasonEndDate)){
                        season = SystemSettings.seasonality.list.find(s => {
                            seasonStartDate = moment.utc(s.start).startOf("day");
                            seasonEndDate = moment.utc(s.end).startOf("day");
                            return today.isSameOrAfter(seasonStartDate) && today.isSameOrBefore(seasonEndDate)
                        })
                    }
                    setSeason(season);
                }

                this.getLocale().then((locale) => {
                    configs.push(locale);
                    this.handleLoading(configs);
                });
            }).catch(err => this.setState({...this.state, error: err}));
        }).catch(err => {
            if (err !== false) {
                this.setState({...this.state, error: err});
            }
        }); //catch of checkforlatestversion
        
        history.listen( location =>  {
            const SystemSettings = getSystemSettings();
            if (SystemSettings.multiDestination && SystemSettings.multiDestination.enabled){
                let qs = QueryStringRetriever();
                if (!qs.s_dest_id){
                    if (!getDestination() && window.location.href.indexOf("select_destination") < 0 && window.location.href.indexOf("account") < 0 && window.location.href.indexOf("login") < 0 && window.location.href.indexOf("shopping-cart")){
                        PushHistory("/select_destination");
                    }
                } else {
                    let destination = [];
                    if (qs.s_dest_id.toString().indexOf(",") >= 0 && qs.s_dest_id.toString().indexOf("all") < 0){
                        destination = qs.s_dest_id.split(",")
                    } else {
                        if (qs.s_dest_id.toString().indexOf("all") >= 0){
                            SystemSettings.multiDestination.list.forEach(dest => {
                                destination.push(parseInt(dest.id))
                            })
                        } else {
                            destination.push(parseInt(qs.s_dest_id))
                        }
                    }
                    if (destination.length > 0) { 
                        if (destination !== getDestination()){
                            setDestination(false);
                            destination.forEach(dest => {
                                if (SystemSettings.multiDestination.list.find(d => d.id === parseInt(dest))){
                                    saveDestination(dest)
                                }
                            })
                        }
                    } 
                    else {
                        PushHistory("/select_destination");
                    }
                }
            }
        });

        LocaleRetriever();
    }

    componentDidCatch(error, errorInfo) {
        if (process.env.NODE_ENV === 'production') {
            this.handleReportError(error, errorInfo);
            console.debug(error, errorInfo);
            this.setState({error: 'An unexpected error occurred.'});
        } else {
            console.error(error);
        }
    }

    CheckForLatestVersion() {
        return new Promise((resolve, reject) => {
            request({
                url: '/meta.json?t=' + new Date().getTime(),
                method: 'GET'
            })
            .then( (result) => {
                if(result.status !== 200){
                    reject('error retrieving version (0)');
                }

                if(global.appVersion !== result.data.version){
                    window.location.reload();
                    reject(false);
                }else{
                    resolve(result.data);
                }
            })
            .catch( () => reject('error retrieving version (1)'));
        });
    }

    generateSessionId(settings) {
        return new Promise((resolve, reject) => {
            request({
                url: settings.api + '/inntopia/session?salesid=' + SalesIDRetriever(),
                method: 'GET'
            })
            .then( (result) => {
                if(result.status !== 200){
                    reject('error setting your session (0)');
                }
                setTimestamp(new Date().getTime())
                setSessionId(result.data.SessionId);
            })
            .catch( () => reject('error setting your session (1)'));

            resolve(true);
        });
    }

    generateSpotlioSession(){
        return new Promise((resolve, reject) => {
            request({
                url: 'https://connect-dev.spotlio.com/session',
                method: 'POST'
            })
            .then( (result) => {
                setSpotlioSessionId(result.data.id);
                resolve(true);
            })
            .catch( () => reject('error setting your session (1)'));
        });
    }

    getLocale() {
        return new Promise((resolve, reject) => {
            import('../LocaleEngine/addLocales').then(locales => {
                resolve(locales.default);
            });
        })
    }

    handleLoading (configs) {
        let state = this.state;
        state = {
            ...state,
            customerState: configs[0],
            settings: configs[1],
            locale: configs[2],
            loading: false
        }
        if (process.env.NODE_ENV === 'development' && window.location.hash === '#crash') {
            state.error = 'forced error';
        }
        
        if (state.settings) {
            if (state.settings.maintenance && state.settings.maintenance.enabled !== false) {
                if (state.settings.maintenance.timezone){
                    let currentTime = moment().tz(state.settings.maintenance.timezone).format("YYYY-MM-DD HH:mm:ss Z")
                    if (currentTime > state.settings.maintenance.startTime && currentTime < state.settings.maintenance.endTime){
                        state.maintenance = true;
                    }
                } else {
                    if (state.settings.maintenance.startTime && state.settings.maintenance.endTime) {
                        const startTime = moment(state.settings.maintenance.startTime, 'YYYY-MM-DD HH:mm:ss Z').utc();
                        const endTime = moment(state.settings.maintenance.endTime, 'YYYY-MM-DD HH:mm:ss Z').utc();
                        const now = moment().utc();
                        if (now.unix() > startTime.unix() && now.unix() < endTime.unix()) {
                            state.maintenance = true;
                        }
                    }
                }
            }

            if (state.settings.operation_hours && state.settings.operation_hours.enabled){
                let currentTime = moment().tz(state.settings.operation_hours.timezone).format("HH:mm")
                if (currentTime < state.settings.operation_hours.startTime || currentTime > state.settings.operation_hours.endTime){
                    state.unoperational = true;
                }
            }
        }

        if (!getSessionId()) {
            this.generateSessionId(state.settings)
            .then((res) => {
                if (state.settings && state.settings.app && state.settings.app.sessionCookie && state.settings.app.sessionCookie.enabled){
                    setCookie(
                        state.settings.app.sessionCookie.name,
                        JSON.stringify(getSessionId()),
                        moment.utc().add(state.settings.app.sessionCookie.expiration, "seconds").toDate(),
                        state.settings.app.sessionCookie.domain,
                        state.settings.app.sessionCookie.path
                    )
                }
            });
        } else {
            let sessionDuration = parseInt(getSystemSettings().sessionDuration) || 21600;
            if ( moment(getTimestamp()).add(sessionDuration, 'seconds') < moment() ){
                setTimestamp(new Date().getTime())
                setSessionId(false);
                window.location.reload();
            }
            if ( 
                (state.settings && state.settings.app && state.settings.app.sessionCookie && state.settings.app.sessionCookie.enabled) 
                && (!getCookie(state.settings.app.sessionCookie.name) 
                || getCookie(state.settings.app.sessionCookie.name).expiration < new Date().getTime()) ){
                setCookie(
                    state.settings.app.sessionCookie.name,
                    JSON.stringify(getSessionId()),
                    moment.utc().add(state.settings.app.sessionCookie.expiration, "seconds").toDate(),
                    state.settings.app.sessionCookie.domain,
                    state.settings.app.sessionCookie.path
                )
            }
        }

        if (!getSpotlioSessionId() && getSystemSettings().spotlioSession){
            this.generateSpotlioSession().then( () => {
                this.handleFinishLoading(state);
            })
        } else {
            this.handleFinishLoading(state);
        }
    }
    
    handleFinishLoading(state) {
        globalGetItinerary({ bundle: 1}).then(()=>{});
        if (state.settings.app.currency.list && state.settings.app.currency.list.length > 1) {
            const userSettings = getUserSettings();
            if (userSettings && userSettings.currencies && userSettings.currencies.selected) {
                if (userSettings.currencies.selected !== state.settings.app.currency.default) {
                    CurrencyDatabase(state.settings).then(() => {
                        this.setState(state);
                    });
                } else {
                    this.setState(state);
                }
            } else {
                this.setState(state);
            }
        } else {
            this.setState(state);
        }
    }

    handleReportError(error, errorInfo) {
        let data = {
            error: ''+error+'',
            stack: errorInfo,
            date: new Date(),
            location: window.location.href
        };

        if(errorInfo.componentStack) {
            data.stack = errorInfo.componentStack;
        }

        let endpoint = 'https://connect-dev.spotlio.com';
        if(getSystemSettings() && getSystemSettings().api) {
            endpoint = getSystemSettings().api;
        }

        request({
            url: endpoint + '/issues/report',
            method: 'POST',
            data: data
        });
    }

    render() {
        if (this.state.loading || this.state.error || this.state.maintenance || this.state.unoperational) {
            if (this.state.error) {
                return (
                    <div className="LoadingScreen">
                        <h1 style={{transform: 'rotate(90deg)'}}>:-(</h1>
                        <p>Our systems returned the following error:</p>
                        <pre>{this.state.error}</pre>
                        <p>Please contact {this.adminMail ? <a href={`mailto:${this.adminMail}`}>{this.adminMail}</a> : 'the website administrator'} for help.</p>
                        {
                            this.state.customerState &&
                            this.state.customerState.customer &&
                            this.state.customerState.customer.urls &&
                            this.state.customerState.customer.urls.length > 0 &&
                            <a href={window && window.location.origin}>Return to website</a>
                        }
                    </div>
                )
            }
            if (this.state.maintenance) {
                return (
                    <ErrorPage
                        noReturn={true}
                        title={this.state.settings.maintenance.title}
                        subtitle={this.state.settings.maintenance.message}
                    />
                )
            }
            if (this.state.unoperational) {
                return (
                    <div className="MaintenanceMode">
                        <h1>{this.state.settings.operation_hours.title}</h1>
                        <p dangerouslySetInnerHTML={{__html: this.state.settings.operation_hours.message}} />
                    </div>
                )
            }
            return null;
        } else {
            const config = getCustomerConfig();
            const retrievedLocale = getLocale() || "en";
            const appLocale = this.state.locale[retrievedLocale].locale;
            const appMessages = this.state.locale[retrievedLocale].messages;

            initGA(this.state.settings);
            initFBPX(this.state.settings);

            return (
                <IntlProvider locale={appLocale} messages={appMessages}>
                    <React.Fragment>
                        <BookingRouter system={this.state.settings} config={config} customerState={this.state.customerState} />
                        <HelpDialog settings={this.state.settings} />
                        <MultiStore settings={this.state.settings} />
                    </React.Fragment>
                </IntlProvider>
            );
        }
    }
}

function mapStateToProps(state) {
    return { form: state.form.form }
}

export default connect(mapStateToProps)(App)
